export class ProjectCostLimitDialogState {
  mode: ProjectCostLimitDialogModes;
}

export enum ProjectCostLimitDialogModes {
  Info = 'info',
  Edit = 'edit'
}
